import { SentenceData } from 'core/models/catalog/bogota-types';
import React from 'react';
import { StoryTree } from './story-tree';

export const Sentence = ({ root: sentence }: { root: SentenceData }) => {
  const { elements } = sentence;
  return <StoryTree elements={elements} />;
};
